import React, { useState } from 'react';

const DynamicForm = ({ formConfig, onSubmit }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const handleChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear error when user starts typing
    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    formConfig.fields.forEach(field => {
      if (field.required && !formData[field.field_name]) {
        newErrors[field.field_name] = `${field.field_label} is required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  const renderField = (field) => {
    const commonProps = {
      name: field.field_name,
      value: formData[field.field_name] || '',
      onChange: (e) => handleChange(field.field_name, field.field_type === 'checkbox' ? e.target.checked : e.target.value),
      placeholder: field.placeholder,
      className: errors[field.field_name] ? 'error' : ''
    };

    switch (field.field_type) {
      case 'text':
      case 'email':
        return <input type={field.field_type} {...commonProps} />;
      
      case 'textarea':
        return <textarea {...commonProps} rows="4" />;
      
      case 'select':
        return (
          <select {...commonProps}>
            <option value="">{field.placeholder || 'Select an option'}</option>
            {field.options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      
      case 'radio':
        return (
          <div className="radio-group">
            {field.options.map((option, index) => (
              <label key={index} className="radio-option">
                <input
                  type="radio"
                  name={field.field_name}
                  value={option.value}
                  checked={formData[field.field_name] === option.value}
                  onChange={(e) => handleChange(field.field_name, e.target.value)}
                />
                {option.label}
              </label>
            ))}
          </div>
        );
      
      case 'checkbox':
        return (
          <label className="checkbox-option">
            <input
              type="checkbox"
              {...commonProps}
            />
            {field.field_label}
          </label>
        );
      
      default:
        return <input type="text" {...commonProps} />;
    }
  };

  return (
    <div className="dynamic-form">
      <h2>{formConfig.form_title}</h2>
      {formConfig.form_description && (
        <p className="form-description">{formConfig.form_description}</p>
      )}
      
      <form onSubmit={handleSubmit}>
        {formConfig.fields.map((field) => (
          <div key={field.id} className="form-group">
            {field.field_type !== 'checkbox' && (
              <label>
                {field.field_label}
                {field.required && <span className="required"> *</span>}
              </label>
            )}
            {renderField(field)}
            {errors[field.field_name] && (
              <span className="error-message">{errors[field.field_name]}</span>
            )}
          </div>
        ))}
        
        <button type="submit" className="btn btn-primary">
          Submit Proposal
        </button>
      </form>
    </div>
  );
};

export default DynamicForm;
